import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { NotificationInfo } from '../../services/notification.schema';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

  constructor(
    private notificationService: NotificationService
  ) { }

  private notificationSubscription: Subscription = null;
  public notificationInfo: NotificationInfo = null;

  ngOnInit(): void {
    this.notificationSubscription = this.notificationService.notification$.subscribe((value: NotificationInfo) => {
      this.notificationInfo = value;
      if (this.notificationInfo.millisecondsUntilClose > 0) {
        setTimeout(() => this.notificationInfo = null, this.notificationInfo.millisecondsUntilClose);
      }
    });
  }

  ngOnDestroy() {
    this.notificationSubscription.unsubscribe();
  }

}
